export function convertToPressureUnits(
  value: number | null,
): number | undefined {
  return value ?? undefined;
}
export function formatPressureString(value: number): string {
  return `${value} PSI`;
}
